import { useState } from 'react';

/**
 * Per-device "Show summary statistics" preference. Gates the KPI cards
 * (Meals in range, Active goals, Calories/day, Time in Range, Logging streak)
 * on the patient Summary feed. OFF by default; toggled on the Profile page.
 *
 * Read-on-mount is enough here (no live cross-page sync needed): the toggle
 * lives on Profile and the feed remounts when the clinician returns to a
 * patient tab, so it always picks up the current value.
 */
const STORAGE_KEY = 'ui.showSummaryStats';

export const readShowSummaryStats = (): boolean => {
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
};

export const useShowSummaryStats = (): [boolean, (next: boolean) => void] => {
  const [value, setValue] = useState<boolean>(readShowSummaryStats);
  const set = (next: boolean) => {
    setValue(next);
    try {
      window.localStorage.setItem(STORAGE_KEY, next ? '1' : '0');
    } catch {
      /* private mode / quota — ignore */
    }
  };
  return [value, set];
};
